import React from "react";
import {
  FaCode,
  FaPaintBrush,
  FaMobileAlt,
  FaRocket,
} from "react-icons/fa";

import "./Development.scss";

const Development = () => {
  return (
    <section className="dev-section">
      {/* Floating graphics */}
      <div className="floating-shape shape1"></div>
      <div className="floating-shape shape2"></div>
      <div className="floating-shape shape3"></div>

      <div className="dev-container">
        {/* LEFT CONTENT */}
        <div className="dev-content">
          <span className="tag"> LACROWNWELLNESS.COM WEB DEVELOPMENT</span>
          <h2>
            Creative Website <span>Design & Development</span>
          </h2>
          <p>
            We build modern, responsive, and high-performance websites
            using the latest technologies to bring your ideas to life.
          </p>
        </div>

        {/* RIGHT GRAPHICS */}
        <div className="dev-cards">
          <div className="dev-card">
            <FaPaintBrush />
            <h4>UI / UX Design</h4>
          </div>

          <div className="dev-card">
            <FaCode />
            <h4>Web Development</h4>
          </div>

          <div className="dev-card">
            <FaMobileAlt />
            <h4>Mobile Friendly</h4>
          </div>

          <div className="dev-card">
            <FaRocket />
            <h4>Fast Performance</h4>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Development;
